var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUparrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M4.37177 0.488322C4.16646 0.281889 3.83354 0.281889 3.62822 0.488316L0.653993 3.47851C0.448668 3.68494 0.448668 4.01963 0.653993 4.22605C0.859323 4.43246 1.19222 4.43246 1.39755 4.22605L3.47422 2.13823L3.47422 9.13823C3.47422 9.43018 3.70961 9.66683 3.99999 9.66683C4.29038 9.66683 4.52577 9.43018 4.52577 9.13823L4.52577 2.13824L6.60241 4.22605C6.80778 4.43246 7.14065 4.43246 7.34601 4.22605C7.55133 4.01963 7.55133 3.68494 7.34601 3.47851L4.37177 0.488322Z",
    fill: "#01B713"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrowGreen);
export default __webpack_public_path__ + "static/media/Uparrow-Green.0e4145ba0d60d01e3b287aeb5ce095a0.svg";
export { ForwardRef as ReactComponent };